import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const treatmentRoutes = [
  {
    path: "/directories/treatment",
    name: "TreatmentList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "treatment" */ "./components/List"),
  },
];
